import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { environment } from "src/environments/environment";
import { BranchSchedule } from "../../branch-day-fleet-site-check";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: 'schedule-list',
    templateUrl: './schedule-list.component.html',
    styleUrls: ['./schedule-list.component.scss']
})
export class ScheduleListComponent implements OnInit {


    /**
     *
     */
    constructor(private authService: MsalService,
                private httpservice: HttpClient,
                private router: Router) {        
    }

    ngOnInit(): void {
        this.loading++;
        this.downloadSchedules();
    }

    loading = 0;

    schedules: BranchSchedule[] = [];


    downloadSchedules() {
            const account = this.authService.instance.getAllAccounts()[0];
            const accessTokenRequest = {
                scopes: ["user.read"],
                account: account,
               };
    
            this.authService.acquireTokenSilent(accessTokenRequest).subscribe(x => {
                const accessToken = x.accessToken;
                const today = new Date();
                
                this.retrieveBranches(accessToken).subscribe(
                        response => {
                            this.schedules = response.result;
                            this.loading--;
                        }
                );
            });  
        };

        retrieveBranches(accessToken: string){
        
                const url = environment.apiUrl + `api/v2/branchschedules`;
                const getObservable = this.httpservice.get<any>(
                    url,
                    {
                        headers: { 
                            "Authorization": accessToken,
                            'Accept': 'application/json', 
                        },
                        'responseType': 'json'
                    },
                );
                return getObservable;
            }

    redirectToScheduleDetail(id: string){
        this.redirectToNewSchedule(`?id=${id}`)
    }

    redirectToNewSchedule(optionalParam: string | undefined = null){
        const path = '/site-checks/schedule';

        const url = `${path}${optionalParam ?? ""}`;

        this.router.navigateByUrl(url);
    }
    
}